/* ═══════════════════════════════════════════════════════
   CINTILANTE — Wishlist Kalini
   Botão PDP de favoritos.
   Persistência: Wishlist Hero JS SDK (fallback localStorage).
   Envio de evento: Workflow Webhooks → Shopify Flow → Clint.

   Config injetada por layout/theme.liquid em window.KaliniWishlistConfig.
   Dados da cliente logada em window.KaliniCustomer.
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var CFG = window.KaliniWishlistConfig || {};
  if (!CFG.enabled) return;

  var T = CFG.texts || {};
  var LS_ITEMS = 'kalini_wishlist_v1';
  var LS_SENT = 'kalini_wishlist_sent_v1';
  var LS_PENDING = 'kalini_wishlist_pending_v1';
  var LS_OPEN_WL = 'kalini_wishlist_open_after_login_v1';
  var PENDING_TTL_MS = 30 * 60 * 1000;

  function log() {
    if (!CFG.debug) return;
    var args = ['[Kalini WL]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function warn() {
    var args = ['[Kalini WL]'].concat(Array.prototype.slice.call(arguments));
    console.warn.apply(console, args);
  }

  /* ─────────────────────────────────────────────────────
     1. Storage local (fallback + estado do botão offline)
     ───────────────────────────────────────────────────── */

  function lsRead(key) {
    try {
      return JSON.parse(localStorage.getItem(key)) || null;
    } catch (e) {
      return null;
    }
  }

  function lsWrite(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* modo privado / cota cheia: segue sem persistir */
    }
  }

  function localItems() {
    var list = lsRead(LS_ITEMS);
    return Array.isArray(list) ? list : [];
  }

  function localAdd(item) {
    var list = localItems();
    var exists = list.some(function (i) {
      return String(i.variantId) === String(item.variantId);
    });
    if (!exists) {
      list.push(item);
      lsWrite(LS_ITEMS, list);
    }
  }

  function localRemove(variantId) {
    lsWrite(
      LS_ITEMS,
      localItems().filter(function (i) {
        return String(i.variantId) !== String(variantId);
      })
    );
  }

  function localHas(variantId) {
    return localItems().some(function (i) {
      return String(i.variantId) === String(variantId);
    });
  }

  /* Dados de cliente capturados pela loja em @cliente-data-*
     (ver assets/custom.js → saveClientData). */
  function getStoredClient(key) {
    try {
      return localStorage.getItem('@cliente-data-' + key) || '';
    } catch (e) {
      return '';
    }
  }

  function persistClient(key, value) {
    if (!value) return;
    if (typeof window.saveClientData === 'function') {
      window.saveClientData(key, value);
      return;
    }
    try {
      var stored = value;
      if (key === 'telefone' || key === 'cep') stored = String(value).replace(/\D/g, '');
      localStorage.setItem('@cliente-data-' + key, stored);
    } catch (e) {
      /* modo privado */
    }
  }

  function normalizePhone(raw) {
    if (!raw) return '';
    var digits = String(raw).replace(/\D/g, '');
    if (!digits) return '';
    /* Número já em formato internacional. */
    if (digits.length > 11 && digits.indexOf('55') === 0) return digits;
    /* DDD + número nacional. */
    if (digits.length === 10 || digits.length === 11) return '55' + digits;
    return digits;
  }

  function isValidPhone(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    /* Aceita 10/11 (nacional) ou 12/13 com 55. */
    if (digits.indexOf('55') === 0 && (digits.length === 12 || digits.length === 13)) {
      digits = digits.slice(2);
    }
    return digits.length === 10 || digits.length === 11;
  }

  function isValidEmail(raw) {
    var email = String(raw || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* Resolve e-mail/telefone/nome: cliente Shopify → localStorage da loja. */
  function resolveIdentity(overrides) {
    var customer = window.KaliniCustomer || {};
    var over = overrides || {};
    var email = String(over.email || customer.email || getStoredClient('email') || '').trim();
    var phone = normalizePhone(over.phone || customer.phone || getStoredClient('telefone') || '');
    var name = String(over.name || customer.name || getStoredClient('nome') || '').trim();
    return {
      email: email,
      phone: phone,
      name: name,
      loggedIn: !!customer.loggedIn,
      hasEmail: !!email,
      hasPhone: !!phone
    };
  }

  /* Máscara BR: (XX) XXXXX-XXXX (celular) ou (XX) XXXX-XXXX (fix dígitos). */
  function maskPhone(raw) {
    var digits = String(raw || '').replace(/\D/g, '').slice(0, 11);
    if (!digits.length) return '';
    if (digits.length <= 2) return '(' + digits;
    var ddd = digits.slice(0, 2);
    var rest = digits.slice(2);
    if (digits.length <= 6) return '(' + ddd + ') ' + rest;
    if (digits.length <= 10) {
      return '(' + ddd + ') ' + rest.slice(0, 4) + '-' + rest.slice(4);
    }
    return '(' + ddd + ') ' + rest.slice(0, 5) + '-' + rest.slice(5);
  }

  /* ─────────────────────────────────────────────────────
     2. Ponte com o SDK do Wishlist Hero
     O SDK carrega de forma assíncrona e dispara o evento
     "wishlist-hero-wishlist-sdk-ready" quando está pronto.
     Requer plano Silver ou superior no app.
     ───────────────────────────────────────────────────── */

  /* O app já mudou o nome do global entre versões. Procuramos por assinatura
     (presença do método AddWishListItem) em vez de confiar num nome fixo. */
  var SDK_NAMES = [
    'WishListHero_SDK',
    'WishlistHero_SDK',
    'WishListHeroSDK',
    'WishlistHeroSDK',
    'wishlistHero_SDK',
    'WishListHero',
    'WishlistHero'
  ];

  function looksLikeSdk(obj) {
    return !!obj && typeof obj.AddWishListItem === 'function';
  }

  /* Varre o window atrás de qualquer objeto com a cara do SDK. */
  function findSdk() {
    for (var i = 0; i < SDK_NAMES.length; i++) {
      if (looksLikeSdk(window[SDK_NAMES[i]])) return window[SDK_NAMES[i]];
    }
    var keys;
    try {
      keys = Object.keys(window);
    } catch (e) {
      return null;
    }
    for (var j = 0; j < keys.length; j++) {
      if (!/wish/i.test(keys[j])) continue;
      try {
        if (looksLikeSdk(window[keys[j]])) return window[keys[j]];
      } catch (e) {
        /* getters que lançam: ignorar */
      }
    }
    return null;
  }

  /* Lista tudo que existe no window relacionado a wishlist — usado no
     diagnóstico quando o SDK não é encontrado. */
  function dumpWishlistGlobals() {
    var found = [];
    try {
      Object.keys(window).forEach(function (k) {
        if (!/wish/i.test(k)) return;
        var tipo;
        try {
          var v = window[k];
          tipo = v === null ? 'null' : typeof v;
          if (tipo === 'object') tipo += ' {' + Object.keys(v).slice(0, 12).join(', ') + '}';
        } catch (e) {
          tipo = '<erro ao ler>';
        }
        found.push(k + ': ' + tipo);
      });
    } catch (e) {
      /* ignora */
    }
    return found;
  }

  var SDK_TIMEOUT_MS = 25000;
  var SDK_POLL_MS = 250;
  var sdkResolved = false;

  /* Combina três estratégias: checagem imediata, o evento oficial do app e
     polling. O polling cobre o caso de o evento já ter disparado antes deste
     script rodar, ou de o app o ter renomeado. */
  var sdkReady = new Promise(function (resolve) {
    function done(sdk) {
      if (sdkResolved) return;
      sdkResolved = true;
      resolve(sdk || null);
    }

    var immediate = findSdk();
    if (immediate) {
      done(immediate);
      return;
    }

    document.addEventListener('wishlist-hero-wishlist-sdk-ready', function () {
      var sdk = findSdk();
      log('Evento wishlist-hero-wishlist-sdk-ready recebido.', sdk ? 'SDK localizado.' : 'SDK ainda não localizado.');
      if (sdk) done(sdk);
    });

    var waited = 0;
    var poll = setInterval(function () {
      var sdk = findSdk();
      waited += SDK_POLL_MS;

      if (sdk) {
        clearInterval(poll);
        log('SDK localizado por polling após ' + waited + 'ms.');
        done(sdk);
        return;
      }

      if (waited >= SDK_TIMEOUT_MS) {
        clearInterval(poll);
        done(null);
      }
    }, SDK_POLL_MS);
  });

  sdkReady.then(function (sdk) {
    if (sdk) {
      log('SDK do Wishlist Hero pronto.');
      return;
    }
    var globais = dumpWishlistGlobals();
    warn(
      'SDK do Wishlist Hero indisponível após ' +
        SDK_TIMEOUT_MS / 1000 +
        's. O botão funciona em modo local — os itens não aparecerão na página do app.\n' +
        'Globais relacionados encontrados na página: ' +
        (globais.length ? '\n  ' + globais.join('\n  ') : 'NENHUM (o script do app não carregou nesta página).') +
        '\nRode window.KaliniWishlist.diagnostico() para mais detalhes.'
    );
  });

  /* Diagnóstico manual — chamar no console do navegador. */
  function diagnostico() {
    var sdk = findSdk();
    var id = resolveIdentity();
    var info = {
      sdkEncontrado: !!sdk,
      metodosDoSdk: sdk ? Object.keys(sdk) : null,
      globaisComWish: dumpWishlistGlobals(),
      identidade: {
        email: id.email || null,
        phone: id.phone || null,
        name: id.name || null,
        loggedIn: id.loggedIn,
        emailFonte: (window.KaliniCustomer && window.KaliniCustomer.email)
          ? 'shopify'
          : getStoredClient('email')
            ? '@cliente-data-email'
            : null
      },
      scriptsDoApp: Array.prototype.slice
        .call(document.querySelectorAll('script[src]'))
        .map(function (s) {
          return s.src;
        })
        .filter(function (src) {
          return /wishlist|revamp|wlh/i.test(src);
        }),
      appEmbedNoDom: !!document.querySelector('[class*="wishlist"], [id*="wishlist"], [data-wlh-id]'),
      config: CFG
    };
    console.log('[Kalini WL] Diagnóstico:', info);
    return info;
  }

  function sdkSafe(fn, fallback) {
    return sdkReady.then(function (sdk) {
      /* Segunda chance: o SDK pode ter aparecido depois do timeout. */
      var active = sdk || findSdk();
      if (!active) return fallback;
      try {
        return fn(active);
      } catch (e) {
        warn('Erro no SDK:', e);
        return fallback;
      }
    });
  }

  /* Monta o payload no formato exigido pelo Wishlist Hero.
     WishlistHash é obrigatório: GetWishListHash() só lê o hash existente;
     GetWishListHash(true) cria a wishlist se ainda não existir (caso típico
     do primeiro "Salvar" de um visitante). */
  function toHeroPayload(item, sdk, identity) {
    var customerId;
    var id = identity || resolveIdentity();

    try {
      if (typeof sdk.GetCustomerId === 'function') customerId = sdk.GetCustomerId();
    } catch (e) {
      /* cliente não logada */
    }

    var hashPromise = Promise.resolve('');
    if (typeof sdk.GetWishListHash === 'function') {
      try {
        hashPromise = Promise.resolve(sdk.GetWishListHash(true)).then(function (hash) {
          return hash || '';
        });
      } catch (e) {
        warn('GetWishListHash falhou:', e);
        hashPromise = Promise.resolve('');
      }
    }

    return hashPromise.then(function (hash) {
      if (!hash) {
        warn(
          'WishlistHash vazio — AddWishListItem será rejeitado pelo app. ' +
            'Confirme plano Silver+ e se window.WishListHero_SDK.GetWishListHash(true) retorna um hash.'
        );
      }

      var payload = {
        ProductId: Number(item.productId),
        ProductTitle: item.title,
        ProductPrice: Number(item.priceAmount) || 0,
        ProductLink: item.url,
        ProductVariantId: Number(item.variantId),
        /* O SDK espera a imagem sem protocolo. */
        ProductImage: String(item.image || '').replace(/^https?:/, ''),
        WishlistHash: hash
      };

      if (customerId) payload.CustomerId = Number(customerId);
      /* Campo não documentado, mas evita o registro "Anonymous" no admin. */
      if (id.email) {
        payload.CustomerEmail = id.email;
        payload.Email = id.email;
      }
      if (id.phone) payload.CustomerPhone = id.phone;
      if (id.name) payload.CustomerName = id.name;
      return payload;
    });
  }

  function heroHas(variantId) {
    return sdkSafe(function (sdk) {
      if (typeof sdk.GetWishListItems !== 'function') return null;
      var items = sdk.GetWishListItems() || [];
      return items.some(function (i) {
        return String(i.ProductVariantId) === String(variantId);
      });
    }, null);
  }

  function heroAdd(item, identity) {
    return sdkSafe(function (sdk) {
      return toHeroPayload(item, sdk, identity).then(function (payload) {
        if (!payload.WishlistHash) return false;
        log('AddWishListItem →', payload);
        return Promise.resolve(sdk.AddWishListItem(payload)).then(function (result) {
          log('AddWishListItem ←', result);
          return result;
        });
      });
    }, false);
  }

  function heroRemove(item) {
    return sdkSafe(function (sdk) {
      if (typeof sdk.DeleteWishListItem !== 'function') return false;
      return toHeroPayload(item, sdk).then(function (payload) {
        if (!payload.WishlistHash) return false;
        return Promise.resolve(
          sdk.DeleteWishListItem({
            ProductVariantId: payload.ProductVariantId,
            WishlistHash: payload.WishlistHash
          })
        );
      });
    }, false);
  }

  /* ─────────────────────────────────────────────────────
     3. Envio do evento para o webhook (Flow → Clint)
     ───────────────────────────────────────────────────── */

  function alreadySent(variantId) {
    var hours = Number(CFG.dedupeHours);
    if (!hours) return false;

    var map = lsRead(LS_SENT) || {};
    var last = map[String(variantId)];
    if (!last) return false;
    return Date.now() - last < hours * 3600 * 1000;
  }

  function markSent(variantId) {
    var map = lsRead(LS_SENT) || {};
    var cutoff = Date.now() - 7 * 24 * 3600 * 1000;

    /* Poda entradas antigas para o objeto não crescer indefinidamente. */
    Object.keys(map).forEach(function (k) {
      if (map[k] < cutoff) delete map[k];
    });

    map[String(variantId)] = Date.now();
    lsWrite(LS_SENT, map);
  }

  function sendEvent(item, contact, origem) {
    if (!CFG.sendEvents) {
      log('Envio de eventos desativado nas configurações do tema.');
      return;
    }
    if (!CFG.webhookUrl) {
      warn('URL do webhook não configurada. Evento não enviado.');
      return;
    }

    var id = resolveIdentity(contact);
    var telefone = id.phone;
    var email = id.email;

    /* Sem identificador não há como o Clint criar o negócio. */
    if (!email && !telefone) {
      log('Sem e-mail nem telefone — evento não enviado.', item.title);
      return;
    }

    if (alreadySent(item.variantId)) {
      log('Evento suprimido pela janela anti-duplicidade:', item.title);
      return;
    }

    var payload = {
      evento: 'wishlist_add',
      origem: origem || 'pdp',
      customer_email: email,
      customer_phone: telefone,
      customer_name: id.name || '',
      customer_logged_in: id.loggedIn,
      product_id: String(item.productId || ''),
      product_variant_id: String(item.variantId || ''),
      product_title: item.title || '',
      product_url: item.url || '',
      product_price: item.priceFormatted || '',
      product_image: item.image || '',
      shop: CFG.shopDomain || '',
      timestamp: new Date().toISOString()
    };

    var headers = { 'Content-Type': 'application/json' };
    if (CFG.webhookHeader && CFG.webhookToken) {
      headers[CFG.webhookHeader] = CFG.webhookToken;
    }

    markSent(item.variantId);

    fetch(CFG.webhookUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
      keepalive: true
    })
      .then(function (res) {
        if (res.ok) {
          log('Evento enviado:', payload.product_title);
        } else {
          warn('Webhook respondeu ' + res.status + '. Confira a URL e o token nas configurações do tema.');
        }
      })
      .catch(function (err) {
        warn(
          'Falha ao enviar o evento (provável bloqueio de CORS no endpoint do webhook). ' +
            'Tentando envio sem resposta. Detalhe:',
          err
        );
        /* Fallback opaco: a requisição sai do navegador mas não conseguimos ler
           a resposta nem enviar headers customizados. Só funciona se o webhook
           aceitar o token no corpo da requisição. */
        try {
          fetch(CFG.webhookUrl, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify(
              Object.assign({}, payload, CFG.webhookToken ? { token: CFG.webhookToken } : {})
            ),
            keepalive: true
          });
        } catch (e) {
          warn('Fallback também falhou:', e);
        }
      });
  }

  /* ─────────────────────────────────────────────────────
     4. API pública
     ───────────────────────────────────────────────────── */

  function salvar(item, contact, origem) {
    var id = resolveIdentity(contact);
    if (id.email) persistClient('email', id.email);
    if (id.phone) persistClient('telefone', id.phone);

    localAdd(item);
    sendEvent(item, id, origem);
    return heroAdd(item, id).then(function (result) {
      if (result === false) {
        warn(
          'Item ficou só no localStorage — não foi gravado no Wishlist Hero. ' +
            'Rode window.KaliniWishlist.diagnostico() e confira o plano Silver+ / app embed.'
        );
      }
      return result;
    });
  }

  function remover(item) {
    localRemove(item.variantId);
    return heroRemove(item);
  }

  function estaSalvo(variantId) {
    return heroHas(variantId).then(function (result) {
      return result === null ? localHas(variantId) : result;
    });
  }

  /* ─────────────────────────────────────────────────────
     4b. Login obrigatório + modal
     ───────────────────────────────────────────────────── */

  var loginModalEl = null;
  var loginPreviousFocus = null;

  function isLoggedIn() {
    return !!(window.KaliniCustomer && window.KaliniCustomer.loggedIn);
  }

  function getLoginModal() {
    if (loginModalEl) return loginModalEl;
    loginModalEl = document.getElementById('KaliniLoginModal');
    return loginModalEl;
  }

  function limparHashWishlist() {
    if (window.location.hash !== '#hero-wishlist') return;
    if (window.history && typeof window.history.replaceState === 'function') {
      window.history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search
      );
    } else {
      window.location.hash = '';
    }
  }

  function markOpenWishlistAfterLogin() {
    try {
      sessionStorage.setItem(LS_OPEN_WL, '1');
    } catch (e) {
      /* modo privado */
    }
  }

  function shouldOpenWishlistAfterLogin() {
    try {
      return sessionStorage.getItem(LS_OPEN_WL) === '1';
    } catch (e) {
      return false;
    }
  }

  function clearOpenWishlistAfterLogin() {
    try {
      sessionStorage.removeItem(LS_OPEN_WL);
    } catch (e) {
      /* modo privado */
    }
  }

  function fecharLogin() {
    var modal = getLoginModal();
    if (!modal) return;
    clearPendingAction();
    clearOpenWishlistAfterLogin();
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('k-login-modal-open');
    if (loginPreviousFocus && typeof loginPreviousFocus.focus === 'function') {
      loginPreviousFocus.focus();
    }
    loginPreviousFocus = null;
  }

  function stashPendingAction(pending) {
    if (!pending || !pending.item) return;
    try {
      sessionStorage.setItem(
        LS_PENDING,
        JSON.stringify({
          origem: pending.origem || 'pdp',
          item: pending.item,
          path: currentPagePath(),
          lineIndex: pending.lineIndex || '',
          lineKey: pending.lineKey || '',
          variantId: pending.variantId || pending.item.variantId || '',
          at: Date.now()
        })
      );
    } catch (e) {
      /* modo privado */
    }
  }

  function readPendingAction() {
    try {
      var raw = sessionStorage.getItem(LS_PENDING);
      if (!raw) return null;
      var pending = JSON.parse(raw);
      if (!pending || !pending.item) return null;
      if (pending.at && Date.now() - pending.at > PENDING_TTL_MS) {
        clearPendingAction();
        return null;
      }
      return pending;
    } catch (e) {
      return null;
    }
  }

  function clearPendingAction() {
    try {
      sessionStorage.removeItem(LS_PENDING);
    } catch (e) {
      /* modo privado */
    }
  }

  function currentPagePath() {
    return window.location.pathname + window.location.search || '/';
  }

  function stayPagePath() {
    var modal = getLoginModal();
    return (
      (modal && modal.getAttribute('data-k-login-stay')) ||
      currentPagePath()
    );
  }

  function setLoginReturnTo(url) {
    var modal = getLoginModal();
    if (!modal) return;
    var form = modal.querySelector('form');
    if (!form) return;

    var field = form.querySelector('input[name="return_to"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      form.appendChild(field);
    }
    field.value = url;

    var checkout = form.querySelector('input[name="checkout_url"]');
    if (checkout) checkout.value = url;
  }

  function loginPageUrl(returnTo) {
    var base = (CFG.loginUrl || '/account/login').split('?')[0];
    return base + '?return_to=' + encodeURIComponent(returnTo || stayPagePath());
  }

  /* destino: 'stay' (PDP/carrinho) ou 'wishlist' (ícone do cabeçalho/menu).
     O login sempre volta à página atual. Se veio do cabeçalho, depois do
     login o boot chama OpenWishList() — o SDK já tem a URL do usuário. */
  function mostrarLogin(destino) {
    if (destino === 'wishlist') {
      clearPendingAction();
      markOpenWishlistAfterLogin();
    }

    var returnTo = stayPagePath();
    var modal = getLoginModal();
    if (!modal) {
      window.location.href = loginPageUrl(returnTo);
      return false;
    }

    setLoginReturnTo(returnTo);
    loginPreviousFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('k-login-modal-open');
    limparHashWishlist();

    /* Não focar e-mail/senha: no iOS isso dispara o Face ID no mesmo gesto
       do clique da wishlist e o AutoFill envia o form (Enter) sozinho. */
    var dialog = modal.querySelector('.k-login-modal__dialog');
    if (dialog) dialog.focus();

    return false;
  }

  function ensureLoggedIn(pending) {
    if (isLoggedIn()) return true;
    if (pending) stashPendingAction(pending);
    else clearPendingAction();
    mostrarLogin('stay');
    return false;
  }

  function enviarLogin(form) {
    if (!form) return;
    HTMLFormElement.prototype.submit.call(form);
  }

  function initLoginModal() {
    var modal = getLoginModal();
    if (!modal || modal.dataset.kwlInit) return;
    modal.dataset.kwlInit = '1';

    modal.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-k-login-close]')) {
        event.preventDefault();
        fecharLogin();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        fecharLogin();
      }
    });

    window.addEventListener('hashchange', function () {
      if (modal && !modal.hidden) limparHashWishlist();
    });

    var form = modal.querySelector('form');
    if (!form) return;

    /* iOS Password AutoFill preenche e dispara submit/Enter. Bloqueamos
       qualquer envio implícito; só o toque no botão Entrar envia. */
    form.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.keyCode !== 13) return;
      event.preventDefault();
      event.stopPropagation();
    });

    var submitBtn = form.querySelector('[data-k-login-submit], .k-login-modal__submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (event) {
        event.preventDefault();
        enviarLogin(form);
      });
    }
  }

  window.KaliniWishlist = {
    salvar: salvar,
    remover: remover,
    estaSalvo: estaSalvo,
    itensLocais: localItems,
    abrir: abrirWishlist,
    pedirLogin: mostrarLogin,
    fecharLogin: fecharLogin,
    diagnostico: diagnostico,
    sdk: findSdk
  };

  /* ─────────────────────────────────────────────────────
     5. Botão da PDP
     ───────────────────────────────────────────────────── */

  /* Lê a variante realmente selecionada no formulário, para o caso de a
     cliente ter trocado de tamanho/cor depois do carregamento da página. */
  function currentVariantId(btn) {
    var scope =
      btn.closest('.new-product__blocks, .main-product__blocks, .product, [id^="MainProduct"]') || document;
    var input = scope.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (input && input.value) return input.value;
    return btn.dataset.variantId;
  }

  function itemFromButton(btn) {
    return {
      productId: btn.dataset.productId,
      variantId: currentVariantId(btn),
      title: btn.dataset.productTitle || '',
      url: btn.dataset.productUrl || window.location.href,
      image: btn.dataset.productImage || '',
      priceAmount: btn.dataset.productPriceAmount || '0',
      priceFormatted: btn.dataset.productPrice || ''
    };
  }

  function setButtonState(btn, saved) {
    btn.classList.toggle('k-wl-ativo', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = btn.querySelector('.k-wl-texto');
    if (label) label.textContent = saved ? T.saved || 'Salvo' : T.save || 'Salvar';
  }

  function mostrarCaptura(btn, item, onDone) {
    var anchor = btn.closest('.k-wishlist-wrap') || btn;
    if (anchor.parentElement.querySelector('.k-wl-capture')) return;

    var known = resolveIdentity();

    var box = document.createElement('div');
    box.className = 'k-wl-capture';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Salvar nos favoritos');

    /* Logada sem celular: só pedimos WhatsApp (e-mail já vem da conta). */
    box.innerHTML =
      '<p class="k-wl-capture__txt"></p>' +
      '<label class="k-wl-capture__label" for="k-wl-phone">WhatsApp</label>' +
      '<input id="k-wl-phone" class="k-wl-capture__input k-wl-capture__phone" type="tel" inputmode="numeric" autocomplete="tel" maxlength="15">' +
      '<p class="k-wl-capture__erro k-wl-capture__erro--phone">Informe um número com DDD: (XX) XXXXX-XXXX</p>' +
      '<div class="k-wl-capture__acoes">' +
      '<button class="k-wl-capture__ok" type="button"></button>' +
      '<button class="k-wl-capture__skip" type="button"></button>' +
      '</div>';

    box.querySelector('.k-wl-capture__txt').textContent =
      T.captureText ||
      'Quer que nossa consultora avise sobre modelagem ou disponibilidade deste item?';
    box.querySelector('.k-wl-capture__ok').textContent = T.captureOk || 'Salvar';
    box.querySelector('.k-wl-capture__skip').textContent = T.captureSkip || 'Salvar sem informar';

    var phoneInput = box.querySelector('.k-wl-capture__phone');
    phoneInput.placeholder = T.capturePlaceholder || '(XX) XXXXX-XXXX';

    anchor.insertAdjacentElement('afterend', box);

    function clearInvalid() {
      box.classList.remove('is-invalid', 'is-invalid-phone');
    }

    function concluir(contact) {
      box.remove();
      onDone(contact || {});
    }

    phoneInput.addEventListener('input', function () {
      clearInvalid();
      var start = phoneInput.selectionStart;
      var before = phoneInput.value.length;
      phoneInput.value = maskPhone(phoneInput.value);
      if (document.activeElement === phoneInput) {
        var pos = phoneInput.value.length - (before - start);
        phoneInput.setSelectionRange(Math.max(pos, 0), Math.max(pos, 0));
      }
    });

    box.querySelector('.k-wl-capture__ok').addEventListener('click', function () {
      clearInvalid();
      var phone = phoneInput.value.trim();

      if (phone && !isValidPhone(phone)) {
        box.classList.add('is-invalid', 'is-invalid-phone');
        phoneInput.focus();
        return;
      }

      concluir({ email: known.email || '', phone: phone || '' });
    });

    box.querySelector('.k-wl-capture__skip').addEventListener('click', function () {
      concluir({ email: known.email || '', phone: '' });
    });
  }

  function initBotao(btn) {
    if (btn.dataset.kwlInit) return;
    btn.dataset.kwlInit = '1';

    estaSalvo(currentVariantId(btn)).then(function (saved) {
      setButtonState(btn, saved);
    });

    btn.addEventListener('click', function () {
      var item = itemFromButton(btn);
      if (!ensureLoggedIn({ origem: 'pdp', item: item })) return;

      btn.setAttribute('aria-busy', 'true');

      estaSalvo(item.variantId).then(function (saved) {
        if (saved) {
          remover(item).then(function () {
            setButtonState(btn, false);
            btn.removeAttribute('aria-busy');
          });
          return;
        }

        var identity = resolveIdentity();

        function finalizar(contact) {
          salvar(item, contact || {}, 'pdp').then(function () {
            setButtonState(btn, true);
            btn.removeAttribute('aria-busy');
          });
        }

        /* Logada com celular: salva direto. Sem celular: abre a caixa de WhatsApp. */
        if (identity.hasPhone) {
          finalizar(identity);
        } else {
          btn.removeAttribute('aria-busy');
          mostrarCaptura(btn, item, function (contact) {
            btn.setAttribute('aria-busy', 'true');
            finalizar(contact);
          });
        }
      });
    });
  }

  function initBotoes(root) {
    (root || document).querySelectorAll('.k-wishlist-btn').forEach(initBotao);
  }

  /* ─────────────────────────────────────────────────────
     6. Remoção no carrinho após salvar nos favoritos
     ───────────────────────────────────────────────────── */

  function aplicarRemocao(lineItem) {
    var drawer = lineItem.closest('cart-drawer');
    var qtyInput = lineItem.querySelector('.quantity__input');
    var index = lineItem.dataset.index || (qtyInput ? qtyInput.dataset.index : '');

    if (drawer && typeof drawer.updateQuantity === 'function' && index) {
      drawer.updateQuantity(index, 0);
      return;
    }

    /* Fallback: dispara o change no input, que o tema já observa. */
    var input = lineItem.querySelector('.quantity__input');
    if (input) {
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ─────────────────────────────────────────────────────
     7. Abrir wishlist (ícone do header)
     Sempre OpenWishList() — o SDK resolve a URL de cada cliente.
     ───────────────────────────────────────────────────── */

  function abrirWishlist() {
    return sdkSafe(function (sdk) {
      var hero = window.WishListHero_SDK || sdk;
      if (hero && typeof hero.OpenWishList === 'function') {
        hero.OpenWishList();
        return true;
      }
      return false;
    }, false).then(function (opened) {
      if (!opened) warn('WishListHero_SDK.OpenWishList indisponível.');
    });
  }

  function onHeaderWishlistClick(event) {
    var link = event.target && event.target.closest
      ? event.target.closest('.k-wl-header-link, .wishlist-hero-header-icon, a[href*="/pages/wishlist"]')
      : null;
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!isLoggedIn()) {
      limparHashWishlist();
      mostrarLogin('wishlist');
      return;
    }

    abrirWishlist();
  }

  /* ─────────────────────────────────────────────────────
     8. Boot
     ───────────────────────────────────────────────────── */

  function findWishlistButton(item) {
    if (!item) return null;
    var buttons = document.querySelectorAll('.k-wishlist-btn');
    var fallback = null;
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (String(btn.dataset.productId) !== String(item.productId)) continue;
      if (item.variantId && String(currentVariantId(btn)) === String(item.variantId)) {
        return btn;
      }
      if (!fallback) fallback = btn;
    }
    return fallback;
  }

  function findCartLine(pending) {
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (pending.lineKey && el.dataset.key === pending.lineKey) return el;
      if (pending.variantId && String(el.dataset.id) === String(pending.variantId)) return el;
    }
    return null;
  }

  function removerLinhaCarrinhoApi(pending) {
    var url = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var payload = { quantity: 0 };
    if (pending.lineKey) payload.id = pending.lineKey;
    else if (pending.variantId) payload.id = String(pending.variantId);
    else if (pending.lineIndex) payload.line = parseInt(pending.lineIndex, 10);
    else return;

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (state) {
        var count = document.querySelector('.header__icons-cart-count');
        if (count && state && typeof state.item_count !== 'undefined') {
          count.textContent = state.item_count;
        }
      })
      .catch(function (err) {
        warn('Não foi possível remover o item do carrinho após o login:', err);
      });
  }

  function aplicarSalvarPdp(item) {
    var btn = findWishlistButton(item);
    if (btn) btn.setAttribute('aria-busy', 'true');

    return estaSalvo(item.variantId).then(function (saved) {
      if (saved) {
        if (btn) {
          setButtonState(btn, true);
          btn.removeAttribute('aria-busy');
        }
        return;
      }

      return salvar(item, resolveIdentity(), 'pdp').then(function () {
        if (btn) {
          setButtonState(btn, true);
          btn.removeAttribute('aria-busy');
        }
      });
    });
  }

  function aplicarSalvarCarrinho(pending) {
    salvar(pending.item, resolveIdentity(), 'carrinho');

    var lineItem = findCartLine(pending);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && lineItem && lineItem.closest('cart-drawer')) {
      drawer.open();
    }

    if (lineItem) {
      aplicarRemocao(lineItem);
      return;
    }

    removerLinhaCarrinhoApi(pending);
  }

  function aplicarAcaoPendente() {
    if (!isLoggedIn()) return Promise.resolve();
    var pending = readPendingAction();
    if (!pending) return Promise.resolve();
    clearPendingAction();
    log('Retomando ação após login:', pending.origem, pending.item && pending.item.title);

    if (pending.origem === 'carrinho') {
      aplicarSalvarCarrinho(pending);
      return Promise.resolve();
    }

    return aplicarSalvarPdp(pending.item);
  }

  function boot() {
    initLoginModal();
    if (isLoggedIn() && shouldOpenWishlistAfterLogin()) {
      clearOpenWishlistAfterLogin();
      abrirWishlist();
    }
    aplicarAcaoPendente().then(initBotoes);
    document.addEventListener('click', onHeaderWishlistClick, true);

    /* O drawer é re-renderizado via innerHTML a cada mudança no carrinho,
       então observamos o DOM para reinicializar botões que apareçam depois
       (quick view, recomendações, drawer). Debounced para não pesar. */
    var rescanTimer = null;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          clearTimeout(rescanTimer);
          rescanTimer = setTimeout(initBotoes, 200);
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    log('Inicializado.', CFG);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
